module.exports = __webpack_public_path__ + "img/trash.adcf4bcc.svg";